/**
 * Affexy "sygnet" logo — rendered from the brand asset (public/sygnet.png).
 * Fills its parent container; used both as the brand mark in the sidebar
 * lockup and as the decorative ornament on the navy CTA cards.
 */
export default function SygnetCluster() {
  return (
    <img
      src={`${import.meta.env.BASE_URL}sygnet.png`}
      alt=""
      aria-hidden
      style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
    />
  )
}
